import moment from "moment";
import { defaultCompare as naturalSort } from "logic/DefaultCompare";
export function sortByDate(d1, d2, sortOrder = "asc") {
  const d1Time = moment(d1);
  const d2Time = moment(d2);
  const [earlier, later] = sortOrder === "asc" ? [d1Time, d2Time] : [d2Time, d1Time];
  if (earlier.isBefore(later)) {
    return -1;
  }
  if (later.isBefore(earlier)) {
    return 1;
  }
  return 0;
}
export function naturalSortIgnoreCase(s1, s2, sortOrder = "asc") {
  return sortOrder === "asc" ? naturalSort(s1.toLowerCase(), s2.toLowerCase()) : naturalSort(s2.toLowerCase(), s1.toLowerCase());
}
